import * as React from "react"
import { Show } from "react-admin"
import { usePermissions, useTranslate } from "ra-core"
import { RecordActionsTabs, SubTabProps } from "components/ui/layouts"
import ScheduleIcon from "@mui/icons-material/Schedule"
import Form from "./form"

function CompanyShow(): JSX.Element  {
     const translate = useTranslate()
    
    const subTabs: SubTabProps[] = [
        { label: translate("resources.schedules.name"), name: "schedules", resource: "companies", icon: <ScheduleIcon/> },
    ]

    return (
        <Show actions={<RecordActionsTabs subTabs={subTabs} resourceParent="companies" />}>
            <Form readonly />
        </Show>
    )
}

export default CompanyShow
